import {
  AttachmentSelector,
  EditMessageForm,
  WithComponents,
} from "stream-chat-react";

/**
 * The edit-message form, with Stream's plain attachment selector instead of the composer's
 * payment-request variant. A payment is a NEW transaction, so it has no place inside an edit of an
 * existing message — and the payment button is the composer's primary action, which would read
 * as "pay" on a form whose only job is to save changed text.
 */
export const ChatEditMessageInput = () => (
  <WithComponents overrides={{ AttachmentSelector }}>
    <EditMessageForm />
  </WithComponents>
);
